export const trackingInfoAdapter = (data) => {
	return {
		process: data?.process,
		status: data?.status,
	};
};
